import { makeRequest } from 'utils/requestLogger';

export default (id, roundtable_id) => makeRequest('delete', `/api/recaps/${id}/roundtable/${roundtable_id}`);


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/recap/deleteGenieRecap.js